var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__content not-found"},[_c('section',{staticClass:"error-404"},[_c('div',{staticClass:"container"},[_c('article',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("generic.pageNotFound")))])])])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3da107f5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/not-found/not-found.vue
// module id = 837
// module chunks = 1